export const PROPERTY_STATE = 'property'

export const FETCH_PROPERTY_REQUEST = 'FETCH_PROPERTY_REQUEST'
export const FETCH_PROPERTY_SUCCESS = 'FETCH_PROPERTY_SUCCESS'
export const FETCH_PROPERTY_FAILURE = 'FETCH_PROPERTY_FAILURE'
export const CLEAR_PROPERTY = 'CLEAR_PROPERTY'

export const FACILITIES_GROUPS_EXCLUDED = [20, 30, 60, 201, 202]
